var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "related-events-component" }, [
    _c("div", { staticClass: "related-events-header" }, [
      _c("span", [
        _vm._v("\n      Event staffing based on expected participation\n    ")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "header-number more-margin-left" }, [
        _vm._v("\n      Screeners: " + _vm._s(_vm.calScreeners) + "\n    ")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "header-number" }, [
        _vm._v("\n      Coaches: " + _vm._s(_vm.calCoaches) + "\n    ")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "header-number" }, [
        _vm._v("\n      Leads: " + _vm._s(_vm.calLeads) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "related-events-body" }, [
      _c("div", { staticClass: "other-events-header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "other-events-header-right" }, [
          _c("div", { staticClass: "other-related-events-info" }, [
            _c("div", { staticClass: "text-related-info" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.countApproved) +
                    " approved events on this date in " +
                    _vm._s(_vm.item.state)
                )
              ]),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.countSubmitted) +
                    " total approved events on this date"
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "other-related-events-selection" },
            [
              _vm._l(_vm.selectItems, function(item) {
                return [
                  _c("EventStatusSelection", {
                    staticClass: "menu-item",
                    attrs: { item: item }
                  })
                ]
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "other-events-body" },
        [
          _c("TableRelatedEvents", {
            staticClass: "modal-body-changeOrderDetail-event-detail",
            attrs: { editable: false, eventId: _vm.item.id }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "other-events-header-left" }, [
      _c("span", { staticClass: "other-events-title" }, [
        _vm._v("Other event")
      ]),
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "other-event-description" }, [
        _c("span", [
          _vm._v(
            "Events pending approval and approved on this day that might impact this one."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f16dac38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f16dac38","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/datatable/RelatedEvent.vue
// module id = 1508
// module chunks = 1